/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { SelectField, TextField, CheckboxField } from '@molecules';
import MediaField from '@organisms/MediaField';
import { Form } from '@organisms';
import { Block, ErrorMessage } from '@atoms';
import { NO_MARGIN_BOTTOM } from '@constants';
import { useIsLOCadmin } from '@hooks';

import { FORM_FIELD } from './constants';

const SponsorForm = ({ initialValues = {}, error, form }) => {
  const isLOCadmin = useIsLOCadmin();

  return (
    <Form form={form} layout="vertical" initialValues={initialValues}>
      <ErrorMessage error={error} variant="block" spaced />
      <Block spaced>
        <SelectField
          {...FORM_FIELD.TYPE}
          wrapperCol={{ span: 17 }}
          selectOptions={{ placeholder: '- Choose a type of sponsor type -' }}
        />
        <TextField {...FORM_FIELD.NAME} />
        <TextField {...FORM_FIELD.URL} />
        <MediaField {...FORM_FIELD.LIGHT_BACKGROUND} />
        <MediaField {...FORM_FIELD.DARK_BACKGROUND} />
        {!isLOCadmin && (
          <CheckboxField
            {...FORM_FIELD.LOGO_SCALE}
            style={NO_MARGIN_BOTTOM}
            labelStyle={{ fontSize: '17px' }}
            labelClassName="ant-form-item-label"
          />
        )}
      </Block>
    </Form>
  );
};

SponsorForm.useForm = () => Form.useForm(FORM_FIELD);

export default SponsorForm;
